import TrainerCard from "./TrainerCard";
import HalfImage from "../../../images/half.jpg";
import "./style.css";

function Trainers({ trainers, isDesktop }: any) {
  return (
    <div
      className="trainers-section-background"
      style={{
        backgroundImage: `url(${HalfImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      id="trainers"
    >
      <div className="text1">EDZŐINK</div>
      <div className="text2">A SZAKÉRTŐK</div>
      <div className="trainer-container">
        {trainers?.map((trainerData: any, index: any) => (
          <TrainerCard
            key={`trainer-${index}`}
            name={trainerData.trainerName}
            pictureName={trainerData.trainerImage}
            instagram={trainerData.trainerInstagram}
            trainerDescription={trainerData.trainerDescription}
            isDesktop={isDesktop}
          ></TrainerCard>
        ))}
      </div>
    </div>
  );
}

export default Trainers;
